import React, { useContext, useState,useEffect,useMemo } from 'react';
import { Table, Button, Icon, Modal, Input } from 'semantic-ui-react';
import styles from "./DataConnections.module.css";
import ConfirmationModal from './ConfirmationModal'; // Import the styled confirmation modal
import DublicateConfirmation from './DublicateConfirmation';
import dataconnection from '../../../api/DataConnection/dataconnection';
import axios from 'axios';

const ConnectionList = ({ onEdit, toolapiendpoint ,loadToolApiendpoint,conloaderSatus,setConloaderStatus,resetCOnnectform }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [selectedDb, setSelectedDb] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [copyModalOpen, setCopyModalOpen] = useState(false);
    const [copyId, setCopyId] = useState(null);
    
    const recordsPerPage = 5;
    
    // Sort data in descending order by created_at
    const sortedData = useMemo(() => {
        if(toolapiendpoint){
            return [...toolapiendpoint].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
    }, [toolapiendpoint]);


    
    // Pagination logic
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = toolapiendpoint ? sortedData.slice(indexOfFirstRecord, indexOfLastRecord) : [];
    const totalPages = toolapiendpoint ? Math.ceil(sortedData.length / recordsPerPage) : [];

    const confirmDelete = () => {
        if (selectedDb) {
            setConloaderStatus(true)
            dataconnection.deleteDataApiConnection(selectedDb.id).then(() => {
                
                setSuccessMessage("Configuration deleted successfully!");
                loadToolApiendpoint();
                setTimeout(() => setSuccessMessage(""), 3000);
                
                closeModal();
            });
            resetCOnnectform(); 
        }
    };

    useEffect(() => {
        if (toolapiendpoint != undefined) {
            setConloaderStatus(false);
        }
    }, [toolapiendpoint]);

    const openModal = (db) => {
        setSelectedDb(db);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedDb(null);
    };

    const openCopyModal = (id) => {
        setCopyId(id);
        setCopyModalOpen(true);
    };
    
    const closeCopyModal = () => {
        setCopyId(null);
        setCopyModalOpen(false);
    };
    
    const confirmCopy = async () => {
        setCopyModalOpen(false);
        try {
            dataconnection.duplicateDataApiConnection(copyId).then(() => {
            setSuccessMessage("Configuration copied successfully!");
            loadToolApiendpoint();
            setTimeout(() => setSuccessMessage(""), 3000);
            })
            resetCOnnectform();
        } catch (error) {
            setSuccessMessage("Configuration copied successfully!");
            setTimeout(() => setSuccessMessage(""), 3000);
            console.error("Error duplicating config:", error);
           
        } finally {
            setCopyId(null);
        }
    };
    
    const onRefresh = async (execute_url) => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${execute_url}`,
            headers: { }
        };
      
      axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setSuccessMessage("Configuration Refresh successfully!");
        loadToolApiendpoint();
        setTimeout(() => setSuccessMessage(""), 3000);

      })
      .catch((error) => {
        console.log(error);
      });
      
    };
    


    return (
        <>
        {
            (toolapiendpoint !== undefined && conloaderSatus == false) ?
            <div style={{ marginTop: "20px" }}>
                {toolapiendpoint.length === 0 ? (
                    <p>No connections available. Please add a new database.</p>
                ) : (
                    <div className={`${styles.datalayerTable}`}>
                       
                        <div style={{ overflowX: 'auto' }}> 
                        {successMessage && (
                                <div style={{ backgroundColor: "#d4edda", color: "#155724", padding: "10px", marginBottom: "10px", borderRadius: "5px" }}>
                                    {successMessage}
                                </div>
                        )}
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>My Endpoint</Table.HeaderCell>
                                        <Table.HeaderCell>Updated Interval</Table.HeaderCell>
                                        <Table.HeaderCell>Add or Replace?</Table.HeaderCell>
                                        <Table.HeaderCell>Actions</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentRecords.map((db) => (
                                        <Table.Row key={db.id}>
                                            <Table.Cell>{db.endpoint_name}</Table.Cell>
                                            <Table.Cell ><span className={styles.truncate}> {db.endpoint_url}</span></Table.Cell>
                                            <Table.Cell>{db.timeInSWC}</Table.Cell>
                                            <Table.Cell>{db.operation}</Table.Cell>
                                            <Table.Cell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <span
                                                    title="Copy Connection"
                                                    onClick={() => openCopyModal(db.id)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-copy ${styles.red || 'text-green-500 hover:text-green-700'}`}></i>
                                                </span>
                                                
                                                    <span
                                                    title="Edit Connection"
                                                    onClick={() => onEdit(db)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-edit ${styles.blue || 'text-blue-500 hover:text-blue-700'}`}></i>
                                                </span>

                                                    <span
                                                    title="Delete Connection"
                                                    onClick={() => openModal(db)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className="la la-trash text-red-500 hover:text-red-700"></i>
                                                </span>

                                                    <span
                                                    title="Refresh Connection"
                                                    onClick={() => onRefresh(db.execute_url)}
                                                    style={{ cursor: 'pointer' }}
                                                    >
                                                    <i className={`la la-refresh ${styles.green || 'text-green-500 hover:text-green-700'}`}></i>
                                                </span>
                                                </div>
                                            </Table.Cell>

                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                            {/* Pagination Controls */}
                            <div className="pagination-controls">
                                <span>Page {currentPage} of {totalPages}</span>
                                <Button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                                    Previous
                                </Button>
                                
                                <Button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                                    Next
                                </Button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Custom Confirmation Modal */}
                
                    <ConfirmationModal
                        open={modalOpen}
                        onClose={closeModal}
                        onConfirm={confirmDelete}
                        
                    />
                    <DublicateConfirmation
                        open={copyModalOpen}
                        onClose={closeCopyModal}
                        onConfirm={confirmCopy}
                        message="Are you sure you want to copy this configuration?"
                    />
            </div> :  <p>Loading...</p>
            
        }
        </>
    );
};

export default ConnectionList;
